import localStorage from "@/utils/localStorage"

export function clearAdminAuthStorage() {
  localStorage.removeItem("_nt")
  localStorage.removeItem("_rt")
  localStorage.removeItem("user")
  localStorage.removeItem("empresa")
}

export async function revokeRefreshTokenOnServer(): Promise<void> {
  const rt = localStorage.getItem("_rt")
  const base = process.env.APP_URL
  if (!rt || !base) return
  try {
    await fetch(`${base}/api/admin/logout`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ refreshToken: rt })
    })
  } catch {
    // ignore
  }
}

/** Redirect to admin login when refresh fails; uses company slug from `/[company]/...` path when present. */
export function redirectToAdminLoginAfterAuthFailure() {
  if (typeof window === "undefined") return
  const m = window.location.pathname.match(/^\/([^/]+)\//)
  const slug = m?.[1]
  if (slug && slug !== "logout" && slug !== "api") {
    window.location.href = `/${slug}/admin`
  } else {
    window.location.href = "/"
  }
}
